import withArchivosAdjuntosDocentes from "../../hoc/Docentes/withArchivosAdjuntosDocentes"
import ArchivosAdjuntos from "../../view/components/RegistroUsuarios/PerfilProfesional/VistaPerfilProfesional/ArchivosAdjuntos"

export default withArchivosAdjuntosDocentes(ArchivosAdjuntos);